<template>

  <div class="p-fluid report-field">
    <div class="p-text-center">

      <img v-if="!overview" :src="url" style="max-width: 100%; max-height: 350px;" :class="[{'image-disabled':guide.disabled}]" :alt="$t('report.edit.device_orientation')"/>
      <img v-else :src="url" style="max-width: 100%; max-height: 250px;" :class="[{'image-disabled':guide.disabled}]" :alt="$t('report.edit.device_orientation')"/>

    </div>
  </div>

    <!-- <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
            <label>{{$t('report.REPORT.'+guide.key)}}</label>
            
        </div>
    </div> -->

    <!-- <div>mode: {{ guide.mode }}</div>
    <div>type: {{ guide.type }}</div>
    <div>key: {{ guide.key }}</div>
    <div>annotation: {{ guide.annotation }}</div> -->


</template>

<script>
export default {
  components: {
  },
  props: {
      section: String,
      guide: Object,
      overview: Boolean,
      extras: Object,
    },
  data() {
    return {
    }
  },
  computed: {
    url: function() {
      if(this.guide.type==='image_device') {
        return this.$images.reportImage(this.extras.modelName);
      }
      return 'assets/irinox/images/report/'+this.guide.url;
    }
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style scoped>

</style>